import { CardModel } from './card.model';
import { DeliveriesModel } from './deliveries.model';
import { Scheduling } from './scheduling';

export class PaymentDataModel {
    public recaptcha_token: string;
    public payment_method: number;
    public installments: number;
    public affiliate_shareable_key: string;
    public card = new CardModel;
    public cards: Array<CardModel> = [];
    public contracts: Array<number> = [];
    public deliveries = new DeliveriesModel;
    public scheduling = new Scheduling;
    public three_ds: object = {};
    public pagar_me_3ds: object = {};
    public fingerprint: string;
    public browser: object = {};
}



// WEBPACK FOOTER //
// /codebuild/output/src1143190010/src/src/app/shared/models/payment/data.model.ts